import { render, staticRenderFns } from "./FieldsTab.vue?vue&type=template&id=2574b7a1&scoped=true"
import script from "./FieldsTab.vue?vue&type=script&lang=js"
export * from "./FieldsTab.vue?vue&type=script&lang=js"
import style0 from "./FieldsTab.vue?vue&type=style&index=0&id=2574b7a1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2574b7a1",
  null
  
)

export default component.exports